<template>
  <v-select
    :items="myResources"
    :loading="loading"
    :error-messages="errors"
    v-bind="$attrs"
    :value="value"
    @input="$emit('input', $event)"
  >
  </v-select>
</template>

<script>
import moment from "moment";

export default {
  name: "LoopBackResourceSelect",
  data() {
    return {
      myResources: [],
      loading: true,
      errors: []
    };
  },
  created() {
    this.loadResources();
  },
  methods: {
    async loadResources() {
      if (!this.url) {
        return;
      }
      this.loading = true;

      try {
        let response = await this.$http.get(`${this.url}/`, {
          params: { filter: this.filter }
        });
        console.debug("lb-select response: ", response.data);
        if (Array.isArray(response.data)) {
          this.myResources = [...response.data];
        } else {
          this.myResources = [response.data];
        }
      } catch (e) {
        this.handleError(e);
      }

      this.loading = false;
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  computed: {
    // ...mapGetters({ lookup: "lookup" }),
  },
  props: {
    filter: Object,
    url: String,
    value: [String, Number]
  }
};
</script>
